import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import api from "@/lib/api";

const CHANGED = "no-buyer-changed";
export const noBuyerChanged = () => window.dispatchEvent(new Event(CHANGED));

// Company-page leads from the last 7 days that reached no buyer and nobody has looked at yet (sidebar badge).
export function useNoBuyerCount(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  useEffect(() => {
    if (!enabled) return undefined;
    let live = true;
    const load = () => api.get("/admin/traffic-access/no-buyer/count")
      .then((r) => { if (live) setCount(r.data.unseen || 0); })
      .catch(() => {});
    load();
    const timer = setInterval(load, 60000);
    window.addEventListener(CHANGED, load);
    return () => {
      live = false;
      clearInterval(timer);
      window.removeEventListener(CHANGED, load);
    };
  }, [enabled, pathname]);
  return count;
}
